import React from 'react'
import { compose } from 'recompose'
import ImageActionModal from './ImageActionModal'
import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'

class ImageActionModalWithRedux extends React.Component {
  static propTypes = {
    ...modalPropTypes,
  }

  handleClose = value => {
    // this.props.modalActions.hideModal({ portalID: value.portalID })
  }

  render() {
    return <ImageActionModal onRequestClose={this.handleClose} />
  }
}

export default compose(withReduxModal)(ImageActionModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/image-management/ImageActionModalWithRedux.js